export const tr = {
    'audio-url': 'Ses bağlantısı',
    cancel: 'İptal',
    'image-url': 'Görsel bağlantısı',
    upload: 'Yükle',
    'video-url': 'Video bağlantısı'
};
